import { Component, OnInit, Input, Output, EventEmitter, ViewChildren, AfterViewInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-addfinetypepopup',
  templateUrl: './addfinetypepopup.component.html',
  styleUrls: ['./addfinetypepopup.component.css']
})
export class AddfinetypepopupComponent implements OnInit {


  @ViewChildren('input')firstipcontrol;

  formname: string = "finetype";

//Display
formmode:string="Add";

//Mode Values
isaddmode:boolean=false;
iseditmode:boolean=false;
isdeletemode:boolean=false;
isviewmode:boolean=false;

isloading: boolean = false;
   isprivilage: boolean = false;
   showProgress: boolean = false;   


//Save Validation
submitted:boolean;
successfully:boolean;
saveloading: boolean;

//Edit Get Values
finetypeColl:any=[];
finetypeBO:any={};
finetypeid:number=0

finetypeform=new FormGroup({
  finetypeid:new FormControl(0),          
  finetypename:new FormControl('',Validators.required),  
 inactive:new FormControl(false),  
});

@Output() emitData = new EventEmitter();


constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
  public router: Router, private toastr: ToastrService, private activeModal: NgbActiveModal,) {

  this.fnServiceChanges();
}
  


fnServiceChanges() {
  this.loginService.serviceAuthChange.subscribe((value) => {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.fnUserFailedForm();
    }

  });
}



ngOnInit() {
  try {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.loginService.fnGetUserRoleList();
    }

  } catch (ex) {
    this.fnShowErrorMsg(ex);
  }
}

fnOnInitForm() {
  try {
    this.isaddmode = true;
    this.finetypeform.reset();
    this.fnInitializeFormGroup();

   
  } catch (ex) {
    this.fnShowErrorMsg(ex);
  }
}
fnCheckUserPririvilage() {
  var _check: boolean = false;
  if (this.finetypeid > 0) {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
  } else {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
  }

  return _check;
}

fnUserFailedForm() {
  this.isprivilage = true;
}
ngAfterViewInit() {
  //this.firstipcontrol.first.nativeElement.focus();
}
fnInitializeFormGroup() {
  this.finetypeform.setValue({
    finetypeid: 0,
    finetypename: '',
    inactive: false
  })
}



//Save Btn Click
fnSaveBtnClick() {
  try {
    if (this.saveloading) {
      return;        
  }
  
    this.submitted = true;
    this.successfully = false;
    //Validate
    if (this.finetypeform.valid) {
      //Check
      this.saveloading = true;

      var data = {
        'finetypeid': this.finetypeid,
        'finetypename': this.finetypeform.get('finetypename').value,
        'inactive': this.finetypeform.get('inactive').value,
        'companyid': this.loginService.fnGetCompanyId(),
        'createdby': this.loginService.fnGetModUserId(),
        'modifiedby': this.loginService.fnGetModUserId(),
      }

console.log(data)
      this.appService.fnCheckFineType(data).subscribe(
        (res) => {
          if (res.json().status === 200) {
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
             
         
                //Insert 
                this.fnInsertFinetype(data);
   
            }
            else {
              if (_checkresult === "name") {
                this.saveloading = false;

                this.finetypeform.controls['finetypename'].setErrors({ 'notfound': true });
              }
            }
          }
          else {
            this.saveloading = false;

            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.saveloading = false;

          this.toastr.error('Error', err);
        });
    }
  } catch (ex) {
    this.saveloading = false;

    this.fnShowErrorMsg(ex);
  }
}

//Insert
fnInsertFinetype(data) {

  this.appService.fnInsertFineType(data).subscribe(
    (res) => {
      this.saveloading = false;

      if (res.json().status === 200) {
        if (res.json().result != "") {

         
          console.log( res.json())
          this.toastr.success('', "The new Finetype has been added successfully.Insert Successfully");
          this.fnInsertActivityLog('INSERT', 0, data.finetypename);
          var result = res.json().result;
          
          var finetypeid = 0;
          if (result.length > 0) {
            finetypeid = result[0].finetypeid
          }
          this.emitData.emit(finetypeid);
          this.activeModal.close(true);


        }  
        else {
          this.loginService.fnAPIError(res.json())
        }
      }
      (err) => {
        this.saveloading = false;        
      }
    },
    (err) => {
      this.toastr.error('Error', err);
    });

}

fnInsertActivityLog(action, refno, desc) {
  try {
    var data = {
      logtype: action,
      logat: this.formname,
      refnum: refno,
      logdescr: desc,
      logby: this.loginService.fnGetModUserId(),
    }


    this.appService.fnInsertActivity(data).subscribe(
      (res) => {
      },
      (err) => {

      });

  } catch{

  }
}
public decline() {
  this.activeModal.close(false);
}


private fnShowErrorMsg(ex) {
  this.toastr.warning('Internal Error', ex);
}


}

